import React from 'react'

export const Message = ({message,color}) => {
    return (
      <div className="ml-3">
        {color === 'green' && (
          <p className="text-success text-bold">{message}</p>
        )}
        {color === 'red' && (
          <p className="text-danger fw-bold ml-1">{message}</p>
        )}
      </div>
    )
}
